// 都道府県選択肢
export const PREFECTURE_OPTIONS = [
  { value: "愛知県", label: "愛知" },
  { value: "岐阜県", label: "岐阜" },
  { value: "三重県", label: "三重" },
  { value: "静岡県", label: "静岡" }
];

// 全都道府県の値（全選択用）
export const ALL_PREFECTURE_VALUES = PREFECTURE_OPTIONS.map((option) => option.value);

// ソート選択肢
export type SortOption = "popularity" | "distance";

export const SORT_OPTIONS = [
  { value: "popularity" as const, label: "人気" },
  { value: "distance" as const, label: "距離" }
] as const;
